import {
  Flex,
  icons,
} from 'web-styled';

import * as S from './styled';

interface Props {
  size?: number,
  avatar?: string | null,
  fullName: string | undefined,
};

const Author = ({
  size = 28,
  avatar = '',
  fullName,
}: Props) => (
  <Flex spacing={5} noPrint>
    <S.Avatar
      size={size}
      onError={(e) => {
        e.target.src = icons.clientAvatarWhitePlaceHolder;
      }}
    >
      <img src={avatar || icons.clientAvatarWhitePlaceHolder} alt={fullName || ''} />
    </S.Avatar>
    <S.Meta>
      <span>Author</span>
      <S.Name>
        {fullName}
      </S.Name>
    </S.Meta>
  </Flex>
);

export default Author;
